import Common from '../../Common';

const WallboardOutgoing = class extends Common {
	browse = (companyId: id) =>
		this.get(`/company/${companyId}/wallboardoutgoing`)

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/wallboardoutgoing/${id}`)

	update = (companyId: id, id: id, wallboard = {}) =>
		this.post(`/company/${companyId}/wallboardoutgoing/${id}`, wallboard)

	create = (companyId: id, body = {}) =>
		this.post(`/company/${companyId}/wallboardoutgoing`, body)

	readData = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/wallboardoutgoing/data/${id}`)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/wallboardoutgoing/${id}`)

	deleteColumn = (companyId: id, id: id, columnId: id) =>
		this.doDelete(`/company/${companyId}/wallboardoutgoing/${id}/column/${columnId}`)

	deleteUser = (companyId: id, id: id, userId: id) =>
		this.doDelete(`/company/${companyId}/wallboardoutgoing/${id}/user/${userId}`)
}

export default WallboardOutgoing
